import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "./ui/select";
import { ACTIONS, FollowupCard } from "./followups";

const EMPTY = { kind: "followup", reason: "", action: "call", instructions: "", due_at: "", alert_before_minutes: 30, assigned_to: "" };

export const FollowupTab = ({ lead }) => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm({ ...form, [k]: v });

  const load = async () => {
    try { const r = await api.get("/followups", { params: { lead_id: lead.id } }); setItems(r.data || []); } catch { /* silent */ }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [lead.id]);

  const save = async () => {
    if (!form.instructions.trim() || !form.due_at) { toast.error("Instructions aur time zaroori hai"); return; }
    if (form.kind === "delay" && !form.reason.trim()) { toast.error("Delay ka reason likhein"); return; }
    setSaving(true);
    try {
      await api.post("/followups", { ...form, lead_id: lead.id, due_at: new Date(form.due_at).toISOString(), alert_before_minutes: Number(form.alert_before_minutes) || 0, assigned_to: form.assigned_to || null });
      toast.success("Follow-up add ho gaya");
      setForm(EMPTY); setOpen(false); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setSaving(false); }
  };

  return (
    <div className="rounded-lg bg-white border border-slate-200 p-6 mt-3 space-y-4" data-testid="followup-tab">
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Follow-ups / Delays</div>
        <Button size="sm" onClick={() => setOpen(!open)} className="bg-teal-700 hover:bg-teal-800 text-white" data-testid="add-followup-btn"><Plus className="w-4 h-4 mr-1" /> Add Follow-up</Button>
      </div>

      {open && (
        <div className="rounded-md bg-slate-50 border border-slate-200 p-4 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm" data-testid="followup-form">
          <div>
            <Label className="text-xs">Type</Label>
            <Select value={form.kind} onValueChange={(v) => set("kind", v)}>
              <SelectTrigger data-testid="fu-kind-select"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="followup">Follow-up</SelectItem><SelectItem value="delay">Delay</SelectItem></SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs">Action</Label>
            <Select value={form.action} onValueChange={(v) => set("action", v)}>
              <SelectTrigger data-testid="fu-action-select"><SelectValue /></SelectTrigger>
              <SelectContent>{Object.entries(ACTIONS).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          {form.kind === "delay" && (
            <div className="sm:col-span-2"><Label className="text-xs">Delay Reason *</Label><Input value={form.reason} onChange={(e) => set("reason", e.target.value)} placeholder="e.g. Server down, customer document pending" data-testid="fu-reason" /></div>
          )}
          <div className="sm:col-span-2"><Label className="text-xs">Kya karna hai (Instructions) *</Label><Textarea rows={2} value={form.instructions} onChange={(e) => set("instructions", e.target.value)} placeholder="e.g. Customer ko call karke status batana" data-testid="fu-instructions" /></div>
          <div><Label className="text-xs">Kab (Date &amp; Time) *</Label><Input type="datetime-local" value={form.due_at} onChange={(e) => set("due_at", e.target.value)} data-testid="fu-due-at" /></div>
          <div><Label className="text-xs">Kitne minute pehle alert</Label><Input type="number" min="0" value={form.alert_before_minutes} onChange={(e) => set("alert_before_minutes", e.target.value)} data-testid="fu-alert-before" /></div>
          <div className="sm:col-span-2"><Label className="text-xs">Kis staff ke liye (optional)</Label><Input value={form.assigned_to} onChange={(e) => set("assigned_to", e.target.value)} placeholder="Staff ka naam" data-testid="fu-assigned-to" /></div>
          <div className="sm:col-span-2 flex gap-2">
            <Button onClick={save} disabled={saving} className="bg-teal-700 hover:bg-teal-800 text-white" data-testid="fu-save-btn">{saving ? "Saving…" : "Save Follow-up"}</Button>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="fu-cancel-btn">Cancel</Button>
          </div>
        </div>
      )}

      {items.length === 0 ? <div className="text-sm text-slate-500">Is request ka koi follow-up nahi hai.</div> :
        <div className="space-y-3">{items.map((f) => <FollowupCard key={f.id} f={f} onChange={load} showLead={false} />)}</div>}
    </div>
  );
};
